import whitelabelService from "../../../../../services/whitelabel/whitelabel.service";
import VesselData from "./vessel-data.entity";

interface VesselApiData {
  vehicle_data: {
    identification: string;
    model: string;
    brand: string;
    version: string;
    vehicle_type: string;
    year_manufacture: string;
  }
}

class Vessel {
  public vesselData: VesselData;

  constructor(data: VesselApiData = {
    vehicle_data: {
      identification: "",
      model: "",
      brand: "",
      version: "",
      vehicle_type: "",
      year_manufacture: "",
    }
  }) {
    this.vesselData = new VesselData(data.vehicle_data);
  }

  public formatPayload() {
    const whitelabelCompany = whitelabelService
      .getWBDataCompany();

    return {
      api_token: whitelabelCompany.api,
      vehicle_data: this.vesselData.formatPayload()
    }
  }
}

export default Vessel;
